module.exports = __webpack_public_path__ + "static/media/water-fall.a6a81aad.svg";